// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_2rJ55","smallLinkTypography":"_1DIkl","titleTypography":"_3uiLZ","cardTitleTypography":"_1WY_V","nameCell":"_22Nzq","truncate":"_2aPQf","base":"OGDsl","statusWarnings":"_2oMnY","statusSuccess":"_171tz","statusError":"_2lunj","noPartnerPlans":"lj6Z3","buttonContainer":"_3L-7t","searchinput":"_2c5A1","icon":"CqtY0","crossIcon":"_2yACc","buttonGreenBorder":"_1xhas","buttonGrayBorder":"_39kM7"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/components/PartnerPlanList.scss
// module id = 329
// module chunks = 0